import React, { useState, useEffect } from 'react';
import Navbar from '../navbar/navbar';
import { redirect, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import UpdateLegend from './legend';

const KgpMap = () => {
  const navigate = useNavigate();

  const serverHost = process.env.REACT_APP_SERVER_HOST
  const [title, setTitle] = useState("Map Wars")
  const [legends, setLegends] = useState(new Map());
  const [selectedBlock, updateSelectedBlock] = useState(null);

  const fetchLegends = () => {
    fetch(`${serverHost}/legends`, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        setLegends(data.legends);
      })
      .catch(error => console.error('Error fetching legends:', error));
  };

  const hackTitle = () => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const finalText = "Map Wars";
    let iteration = 0;
    let interval = null;
  
    clearInterval(interval);
    interval = setInterval(() => {
      setTitle(prevTitle => {
        return finalText
          .split("")
          .map((letter, index) => {
            if (index < iteration) {
              return finalText[index];
            }
            return letters[Math.floor(Math.random() * letters.length)];
          })
          .join("");
      });
  
      if (iteration >= finalText.length) {
        clearInterval(interval);
      }
  
      iteration += 1 / 3;
    }, 30);
  };

  useEffect(() => {
    hackTitle();
    fetchLegends();
    const interval = setInterval(() => {
      fetchLegends();
    }, 1*60*1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleAuth = () => {
      if (sessionStorage.getItem("user_id") === null) {
        console.log("Not Authenticated");
        navigate('/');
      }
    };

    handleAuth();
  }, [navigate]);

  return (
    <>
      <Navbar />
      <Container>
        <Info>
          <Logo src="images/swords.png" alt="Storytelling" />
          <Title>{title}</Title>
          <Subtitle>Suggest, Support or Defend names of your favourite places</Subtitle>
          <Instructions>
            <h3>Instructions</h3>
            <Steps>
              <Step>Choose any block of your choice</Step>
              <Step>Suggest, Support, and Defend an appropriate name that you like</Step>
              <Step>The name with the most votes will be picked as the Legend for that block</Step>
            </Steps>
          </Instructions>
        </Info>
        <KgpMapContainer>
          <img src="images/map.png" alt="kgp map" />
          <OverlayContainer>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(id => (
              <div
                key={id}
                style={{
                  background: legends[id]?.color ? `${legends[id]?.color}80` : 'rgba(255, 255, 255, 0.3)',
                  border: (selectedBlock===id) ? "1px solid rgba(81, 203, 238, 1)" : "",
                  boxShadow: (selectedBlock===id) ? "0 0 5px rgba(81, 203, 238, 1)" : "",
                }}
                title="Click to edit"
                onClick={() => updateSelectedBlock(id)}
              >
                {legends[id]?.name || ""}
              </div>
            ))}
          </OverlayContainer>
        </KgpMapContainer>
        {selectedBlock !== null && (
          <UpdateLegend selectedBlock={selectedBlock} onClose={() => updateSelectedBlock(null)} />
        )}
      </Container>
      <NavigationBar style={{ display: "none", fontSize: '12px' }}>
        <Section>
          <NavButton style={{ color: 'white' }}>
            <i className='fa fa-map' />
            Play
          </NavButton>
        </Section>
        <Section>
          <NavButton onClick={() => navigate('/dashboard', { state: { navToSection: 1 } })} style={{ color: 'lightgrey' }}>
            <i className='fa fa-comments' />
            Feed
          </NavButton>
        </Section>
        <Section>
          <NavButton onClick={() => navigate('/dashboard', { state: { navToSection: 2 } })} style={{ color: 'lightgrey' }}>
            <i className='fa fa-bullhorn' />
            Chat
          </NavButton>
        </Section>
        <Section>
          <NavButton onClick={() => navigate('/dashboard', { state: { navToSection: 3 } })} style={{ color: 'lightgrey' }}>
            <i className='fa fa-users' />
            Friends
          </NavButton>
        </Section>
      </NavigationBar>
    </>
  );
};

export default KgpMap;

const Container = styled.main`
  display: flex;
  align-items: center;
  height: 86vh;
  background-color: white;
  justify-content: space-around;

  @media only screen and (max-width: 600px) {
    height: 88vh;
    flex-direction: column;
    justify-content: flex-start;
    // gap: 20px;
    overflow-y: hidden;
    // padding: 20px 0;
  }
`;

const NavigationBar = styled.div`
  @media only screen and (max-width: 600px) {
    background: #6559a2;
    justify-content: space-around;
    height: 6vh;
    padding: 0 10px;
    align-items: center;
    display: flex !important;
  }
`;

const Section = styled.div``;

const NavButton = styled.div`
  color: white;
  display: flex;
  gap: 2px;
  flex-direction: column;
  align-items: flex-start;

  i {
    font-size: 22px;
  }
`;

const KgpMapContainer = styled.div`
  height: auto;
  // width: 40vw;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
  position: relative;

  img {}

  @media only screen and (max-width: 600px) {
    scale: 0.6;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 7px 14px, rgba(0, 0, 0, 0.22) 0px 5px 5px;
  }
`;

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);

  div {
    font-size: 22px;
    color: darkslategrey;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    text-shadow: 
        1px 1px 0 #ffffff,
        -1px 1px 0 #ffffff,
        1px -1px 0 #ffffff,
        -1px -1px 0 #ffffff;
  }

  @media only screen and (max-width: 600px) {
    div {
      font-size: 20px;
    }
  }
`;

const Info = styled.div`
  text-align: center;

  @media only screen and (max-width: 600px) {
    margin: 10% 0 0 0;
  }
`;

const Logo = styled.img`
  @media only screen and (max-width: 600px) {
    height: 32px; 
  }
`;

const Title = styled.h1`
  margin: 0;
  text-shadow: 3px 1.5px 0 #abdeb6;
  font-family: 'Space Mono', monospace;
  font-size: 4rem;
  padding: 5px 15px;
  border-radius: 10px;

  &:hover {
    background: #6559A2;
    color: white;
  }

  @media only screen and (max-width: 600px) {
    margin: 0; 
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 20px;
  color: #6559A2;
  font-style: italic;
  margin: 0 0;

  @media only screen and (max-width: 600px) {
    font-size: 12px; 
  }
`;

const Instructions = styled.div`
  margin-top: 40px;
  border-radius: 5px;
  padding: 10px 20px;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;
  text-align: left;

  h3 {
    margin: 0;
  }

  @media only screen and (max-width: 600px) {
    display: none; 
  }
`;

const Steps = styled.ol`
  padding-inline-start: 5%;
`;

const Step = styled.li`
  font-size: 14px;
  margin-bottom: 2%;
`;
